module.exports = __webpack_public_path__ + "img/bucket_stopped.4c37ca8b.svg";